export default "__VITE_ASSET__BrDJNstl__"